import "../../../CommonImports";
import "../../../Core/core.css";
import * as React from "react";
import { Tooltip } from '../../../TooltipEx';
import { css } from '../../../Util';
export class Time extends React.Component {
    constructor(props) {
        super(props);
        this.timerId = 0;
        this.state = {
            output: ""
        };
    }
    static getDerivedStateFromProps(props) {
        return { output: props.getTimeString() };
    }
    render() {
        const props = {
            "aria-hidden": this.props.ariaHidden,
            className: css(this.props.className, "bolt-time-item white-space-nowrap")
        };
        let TagName = "span";
        if (this.props.dateTime) {
            TagName = "time";
            props.dateTime = this.props.dateTime.toISOString();
        }
        const ariaLabel = this.props.ariaLabel ? `${this.state.output} ${this.props.ariaLabel || ""}` : undefined;
        let content = (React.createElement("span", { className: "text-ellipsis", "aria-label": ariaLabel, tabIndex: this.props.tabIndex },
            React.createElement(TagName, Object.assign({}, props), this.state.output)));
        if (this.props.tooltipProps) {
            content = React.createElement(Tooltip, Object.assign({}, this.props.tooltipProps), content);
        }
        return content;
    }
    componentDidUpdate(prevProps) {
        this.cancelNextRefresh();
        this.setNextRefresh();
    }
    componentDidMount() {
        this.setNextRefresh();
    }
    componentWillUnmount() {
        this.cancelNextRefresh();
    }
    cancelNextRefresh() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = 0;
        }
    }
    setNextRefresh() {
        const t = this.props.getNextInterval();
        if (t !== -1) {
            this.timerId = window.setTimeout(() => {
                this.setState({
                    output: this.props.getTimeString()
                });
            }, t);
        }
    }
}
